export { default } from './ListItemIcon';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/ListItemIcon/index.js
// module id = 434
// module chunks = 121